export interface ForemanDateToProcess {
  date: Date;
}
